import FormApi from '@/store/api/form';

import { uniqueId, trim, removeKey } from '@/helpers';

const state = {
    uploadEndpoint: trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_UPLOAD_ROUTE}`,
        '/'
    )
};

const getters = {};
const actions = {
    sendFormToApi({ dispatch }, payload) {
        const success_message = {
            id: uniqueId(),
            title: 'Erfolgreich',
            text: 'Ihre Nachricht wurde erfolgreich versendet.',
            type: 'success',
            autoclose: 5000
        };
        const error_message = {
            id: uniqueId(),
            title: 'Fehler',
            text: 'Ihre Nachricht konnte nicht versendet werden.',
            type: 'danger',
            autoclose: 5000
        };
        payload = removeKey(payload, '__typename');
        return FormApi.create(payload)
            .then(
                // eslint-disable-next-line
                (response) => {
                    dispatch('message/addMessage', success_message, { root: true });
                }
            )
            .catch(error => {
                console.log(error);
                dispatch('message/addMessage', error_message, { root: true });
            });
    }
};

const mutations = {};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
